<template>
  <div class="unusable-feature-section">
    <h4
      class="unusable-feature-section__title"
      v-html="$tc('CancelPaidPlan.EditPage.unusableFeatureTitle')"
    />

    <div class="unusable-feature-section__list">
      <figure class="unusable-feature-section__item">
        <img :src="require('@/assets/img/CanselPaidPlanPage/unusable01.jpg')" alt="" />
        <figcaption v-text="$tc('CancelPaidPlan.EditPage.unusable.gps')" />
      </figure>

      <figure class="unusable-feature-section__item">
        <img :src="require('@/assets/img/CanselPaidPlanPage/unusable02.jpg')" alt="" />
        <figcaption v-text="$tc('CancelPaidPlan.EditPage.unusable.radio')" />
      </figure>

      <figure class="unusable-feature-section__item">
        <img :src="require('@/assets/img/CanselPaidPlanPage/unusable03.jpg')" alt="" />
        <figcaption v-text="$tc('CancelPaidPlan.EditPage.unusable.highlight')" />
      </figure>

      <figure class="unusable-feature-section__item">
        <img :src="require('@/assets/img/CanselPaidPlanPage/unusable04.jpg')" alt="" />
        <figcaption v-text="$tc('CancelPaidPlan.EditPage.unusable.ranking')" />
      </figure>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 有料会員解約: 使用できなくなる機能 セクション
 */
export default defineComponent({
  name: 'UnusableFeatureSection',
  components: {},
})
</script>

<style lang="scss" scoped>
.unusable-feature-section {
  width: 100%;
  padding: 24px 20px 0;
  border-top: 1px solid $black10;

  &__title {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 0.5em;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 1.54;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
    color: $black;
  }

  &__list {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: min(100%, 700px);
    margin: 0 auto;
    gap: 24px 0;

    @media screen and (min-width: $responsiveTabletWidth) {
      flex-wrap: nowrap;
      gap: 30px;
    }
  }

  &__item {
    width: calc(44.67vw - 15px);
    text-align: center;

    @media screen and (min-width: $responsiveTabletWidth) {
      width: auto;
      flex: 1;
    }

    figcaption {
      margin-top: 14px;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      font-feature-settings: 'palt' on;
      color: #00a69c;
    }
  }
}
</style>
